import SearchSimple from '../../../../../../components/SearchSimples/SearchSimple';
import SubViewOptions from '../SubViewOptions';
import { Box } from '@mui/material';
import { CustomSelect } from '../../../../../../components/CustomSelect';
import CustomDateTimePicker from '../../../../../../components/CustomDateTimePicker';
import PeriodReviewTableApp from "./Functionality/PeriodReviewTableApp";
import CustomTable from "../../../../../../components/table/CustomTable";
import {DEFAULT_PAGINATION_START} from "../../../../../../components/table/Model/TableModel";

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : FullStack Developer
 * @Email : kpozos@ibl.mx
 *
 */
const PeriodReviewTable = ({
    activeStep,
    subView,
    option,
    changeSubViewManage,
    registerAction,
    setBodyForExport,
    searchElement,
    setSearchElement,
    setSimpleSearch,
    search,
    setSearch,
    modified,
    setModified
}) => {

    const {
        setResults,
        tableId,
        thead,
        tbody,
        pagination,
        searchId,
        rowsPerPage,
        handleChange,
        item,
        departments,
        getAttendancePeriodReview,
        getData
    } = PeriodReviewTableApp({
        searchElement,
        setBodyForExport,
        option,
        modified,
        setModified,
        registerAction,
        activeStep,
        subView
    });

    return (
        <>
            <div className='d-flex'>
                <SubViewOptions subView={subView} changeSubViewManage={changeSubViewManage} />
                <div className='w-100 ml-4'>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        search={search}
                        setSearch={setSearch}
                        rowsPerPage={rowsPerPage}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={null}
                        supplierId={null}
                        callApi={() => getData(DEFAULT_PAGINATION_START, { searchElement})}
                        resetApi={() => getData(DEFAULT_PAGINATION_START, {searchElement: ''})}
                    />
                </div>
            </div>
            { getAttendancePeriodReview &&
                <div className={'row mt-4 p-0 m-0'}>
                    <Box className='col-sm-12 col-md-12 col-lg-4 col-xl-4 pl-0 pr-sm-0 pr-md-3'>
                        <CustomDateTimePicker
                            id={'dp_pr_start_date'}
                            name={'startDate'}
                            trans={'start_date_at_time'}
                            value={getAttendancePeriodReview?.startDate}
                            required={true}
                            disabled={true}
                        />
                    </Box>

                    <Box className='col-sm-12 col-md-12 col-lg-4 col-xl-4 px-0'>
                        <CustomDateTimePicker
                            id={'dp_pr_end_date'}
                            name={'endDate'}
                            trans={'end_date_at_time'}
                            value={getAttendancePeriodReview?.endDate}
                            required={true}
                            disabled={true}
                        />
                    </Box>
                    <Box className='col-sm-12 col-md-12 col-lg-4 col-xl-4 pl-sm-0 pl-md-3 pr-0'>
                        <CustomSelect
                            id={'slt_pr_department'}
                            name={'departmentId'}
                            value={item?.departmentId}
                            key={item?.departmentId}
                            keyName='id'
                            onChange={handleChange}
                            list={departments}
                            trans={'department'}
                            label={'lbl_pr_department'}
                            required={false}
                            showNoSelectionOption={true}
                        />
                    </Box>
                </div>
            }

            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={false}
                thead={thead}
                tbody={tbody}
                columnActions={false}
                textNotInformation={getAttendancePeriodReview ? 'no_attendance_records_to_review_available' : 'there_not_period_active'}
            />

            {pagination()}
        </>
    );
};

export default PeriodReviewTable;
